import React from "react";

const Blog = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#e8e2d4]">
      <h1 className="text-5xl font-bold text-[#422f40] mb-6">Blog</h1>
      <p className="text-xl text-[#422f40]">Our latest posts will appear here.</p>
    </div>
  );
};

export default Blog; 